import { combineReducers } from 'redux'
import update from 'immutability-helper'
import { OrderedSet } from 'immutable'
import * as AT from '../actions/_types'

export const conversations = (
  prevState = {
    byId: {},
    activeConvos: createDefaultPaginatedConvoData(),
    allConvos: createDefaultPaginatedConvoData(),
    locations: [],
    search: '',
    messageType: 'all',
  },
  action,
) => {
  switch (action.type) {
    case AT.CONVERSATIONS_RECEIVE_NOTIFICATION:
    case AT.CONVERSATIONS_RECEIVE:
    case AT.CONVERSATIONS_RECEIVE_NEXT_PAGE: {
      const nextConversationsById = update(prevState.byId, {
        $merge: action.conversations,
      })

      const { listName } = action

      return {
        ...prevState,
        byId: nextConversationsById,
        [listName]: reducePaginatedConversations(prevState[listName], action),
      }
    }
    case AT.CONVERSATIONS_ACTIVATE: {
      const { convoId, listName } = action
      const { byId } = prevState

      byId[convoId].active = true

      const nextConversationsById = update(prevState.byId, { $merge: byId })

      const paginatedList = reducePaginatedConversations(
        prevState[listName],
        action,
      )

      const nextIdsList = OrderedSet(
        Object.keys(byId)
          .filter(id => byId[id].active)
          .sort(
            (a, b) =>
              new Date(byId[b].last_message) - new Date(byId[a].last_message),
          )
          .map(id => byId[id].id),
      )

      return {
        ...prevState,
        byId: nextConversationsById,
        [listName]: { ...paginatedList, idsList: nextIdsList },
      }
    }
    case AT.CONVERSATIONS_DELETE: {
      const { idToDelete, listName } = action
      const filteredById = { ...prevState.byId }

      delete filteredById[idToDelete]

      return {
        ...prevState,
        byId: filteredById,
        [listName]: reducePaginatedConversations(prevState[listName], action),
      }
    }
    case AT.CONVERSATIONS_INACTIVATE: {
      const { idToInactivate, listName } = action
      const { byId } = prevState

      byId[idToInactivate].active = false

      return {
        ...prevState,
        byId,
        [listName]: reducePaginatedConversations(prevState[listName], action),
      }
    }
    case AT.CONVERSATIONS_PAGE_NUM:
    case AT.CONVERSATIONS_FETCHING:
    case AT.CONVERSATIONS_FETCHED: {
      const { listName } = action

      return {
        ...prevState,
        [listName]: reducePaginatedConversations(prevState[listName], action),
      }
    }
    case AT.CONVERSATIONS_UPDATE_ONE: {
      // TODO: refactor this crap
      const nextConvoVal = reduceConversationById(
        prevState.byId[action.conversationId],
        action,
      )

      const nextConvo = { [action.conversationId]: nextConvoVal }

      const nextConversationsById = update(prevState.byId, {
        $merge: nextConvo,
      })

      return {
        ...prevState,
        byId: nextConversationsById,
      }
    }
    case AT.CONVERSATIONS_CREATING: {
      return {
        ...prevState,
        creatingNewConversation: action.receivedResponse,
      }
    }
    case AT.CONVERSATIONS_ADD_CREATED: {
      const { conversation } = action
      const { byId: oldById } = prevState
      const byId = { ...oldById }
      byId[conversation.id] = conversation
      return {
        ...prevState,
        byId,
      }
    }
    case AT.CONVERSATIONS_UPDATE_SUBJECT: {
      return {
        ...prevState,
        newConversationSubject: action.subject,
      }
    }
    case AT.CONVERSATIONS_UPDATE_SEARCH: {
      return {
        ...prevState,
        search: action.search,
      }
    }
    case AT.CONVERSATIONS_UPDATE_MSG_TYPE: {
      return {
        ...prevState,
        messageType: action.messageType,
      }
    }
    case AT.CONVERSATIONS_RECEIVE_LOCATIONS: {
      return {
        ...prevState,
        locations: action.locations,
      }
    }
    default: {
      return prevState
    }
  }
}

function reducePaginatedConversations(
  prevState = createDefaultPaginatedConvoData(),
  action,
) {
  switch (action.type) {
    case AT.CONVERSATIONS_ACTIVATE:
    case AT.CONVERSATIONS_RECEIVE_NOTIFICATION: {
      const nextIdsList = OrderedSet([...action.idsList]).union(
        prevState.idsList,
      )

      return {
        ...prevState,
        idsList: nextIdsList,
      }
    }
    case AT.CONVERSATIONS_RECEIVE: {
      return {
        ...prevState,
        idsList: OrderedSet(action.idsList),
      }
    }
    case AT.CONVERSATIONS_RECEIVE_NEXT_PAGE: {
      const nextIdsList = prevState.idsList.union(action.idsList)

      return {
        ...prevState,
        idsList: nextIdsList,
      }
    }
    case AT.CONVERSATIONS_PAGE_NUM: {
      return {
        ...prevState,
        pageNum: action.nextPageNum,
        totalPages: action.totalPages,
      }
    }
    case AT.CONVERSATIONS_FETCHING: {
      return {
        ...prevState,
        isFetching: true,
      }
    }
    case AT.CONVERSATIONS_FETCHED: {
      return {
        ...prevState,
        isFetching: false,
      }
    }
    case AT.CONVERSATIONS_DELETE: {
      const { idToDelete } = action

      const filteredIdsList = OrderedSet(prevState.idsList).delete(idToDelete)

      return {
        ...prevState,
        idsList: filteredIdsList,
      }
    }
    case AT.CONVERSATIONS_INACTIVATE: {
      const { idToInactivate } = action

      const filteredIdsList = OrderedSet(prevState.idsList).delete(
        idToInactivate,
      )

      return {
        ...prevState,
        idsList: filteredIdsList,
      }
    }
    default: {
      return prevState
    }
  }
}

function createDefaultPaginatedConvoData() {
  return {
    pageNum: 1, // {number} when fetching a convo, which page should I get?
    totalPages: 1, // {number} how many pages of convos are there altogether?
    idsList: OrderedSet([]), // {OrderedSet} conversation ids in display order
    isFetching: false, // {boolean} is a request in progress?
  }
}

function reduceConversationById(prevState = {}, action) {
  switch (action.type) {
    case AT.CONVERSATIONS_UPDATE_ONE: {
      const updates = { seen: action.seen, subject: action.subject }
      const nextConvo = update(prevState, { $merge: updates })

      return nextConvo
    }
    default: {
      return prevState
    }
  }
}

export const messages = combineReducers({
  byId: reduceMessagesById,
  dataByConversation,
})

function reduceMessagesById(prevState = {}, action) {
  switch (action.type) {
    case AT.MESSAGES_RECEIVE_IN_BULK: {
      return {
        ...prevState,
        ...action.messagesById,
      }
    }
    case AT.MESSAGE_RECEIVE_ONE: {
      const { message } = action
      return {
        ...prevState,
        [message.id]: message,
      }
    }
    case AT.MESSAGE_UPDATE_STATUS: {
      const { textId, status } = action
      if (prevState.hasOwnProperty(textId)) {
        const nextText = update(prevState[textId], { $merge: { status } })
        return {
          ...prevState,
          [textId]: nextText,
        }
      }
      return { ...prevState }
    }
    default: {
      return prevState
    }
  }
}

function dataByConversation(prevState = {}, action) {
  switch (action.type) {
    case AT.MESSAGE_ADD_MEDIA:
    case AT.MESSAGES_ADD_TO_CONVO:
    case AT.MESSAGE_APPEND_TO_LIST:
    case AT.MESSAGE_LOADING:
    case AT.MESSAGE_LOADED:
    case AT.MESSAGE_SENDING:
    case AT.MESSAGE_SEND_DONE: {
      const { conversationId } = action
      const nextState = reduceDataByConversation(
        prevState[conversationId],
        action,
      )

      return {
        ...prevState,
        [action.conversationId]: nextState,
      }
    }
    default: {
      return prevState
    }
  }
}

// handles updates to message metadata as it relates to its parent conversation
function reduceDataByConversation(
  prevState = {
    isLoading: false,
    isSending: false,
    isStale: false,
    messageIds: [],
    lastFetch: 0,
    attachedMedia: null,
  },
  action,
) {
  switch (action.type) {
    case AT.MESSAGES_ADD_TO_CONVO: {
      return {
        ...prevState,
        messageIds: action.listOfIds,
      }
    }
    case AT.MESSAGE_APPEND_TO_LIST: {
      const { messageId } = action
      const prevMessagesList = prevState.messageIds
      const nextMessagesList = update(prevMessagesList, { $push: [messageId] })

      return {
        ...prevState,
        messageIds: nextMessagesList,
      }
    }
    case AT.MESSAGE_SENDING: {
      return {
        ...prevState,
        isSending: true,
      }
    }
    case AT.MESSAGE_SEND_DONE: {
      return {
        ...prevState,
        isSending: false,
      }
    }
    case AT.MESSAGE_LOADING: {
      return {
        ...prevState,
        isLoading: true,
      }
    }
    case AT.MESSAGE_LOADED: {
      return {
        ...prevState,
        isLoading: false,
      }
    }
    case AT.MESSAGE_ADD_MEDIA: {
      return {
        ...prevState,
        attachedMedia: action.media,
      }
    }
    default: {
      return prevState
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/conversations-messages.js